<template>
  <div id="inside" :class="largura >= 500 ? 'page-wrapper-desktop' : ''">
    <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'">
      <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'">
        <div class="row">
          <div class="col-12 text-body px-2 mb-2">
            <button
              class="justify-content-left text-decoration-none btn-link flex-row d-flex align-items-center pr-2 pb-2 pl-1 text-primary"
              @click="back()"
            >
              <i class="fa fa-chevron-left fa-fw pull-left text-info"></i>
              Voltar
            </button>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-12 text-body pr-0">
            <h5 class="text-bold mt-2">Confirmar negociação</h5>
            <HeaderOptions />
          </div>
        </div>
      </div>
    </div>
    <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'">
      <div :class="largura < 500 ? 'card m-1' : 'card'">
            <div class="card-header px-3">
              <div class="row">
                <div class="col-lg-12 col-12">
                  <h5 class="text-body">Resumo da negociação</h5>
                </div>
              </div>
              <hr class="my-2" />
            </div>
            <div class="card-body mb-2 pb-2 pt-0">
              <div class="row mx-0 px-1">
                <div class="col-12 px-0" style="font-weight: bold; color: #2a2a2a;">
                  {{ fromToConsorcioProduct[debtsConsorcio[0].product] }}
                </div>
              </div>
              
              <div class="row mx-0 px-1">
                <div class="col-6 px-0"><p class="mb-0">Grupo</p></div>
                <div class="col-6 px-0 text-right"><p class="text-body mb-0">{{ debtsConsorcio[0].group }}</p></div>
              </div>
              <div class="row mx-0 px-1">
                <div class="col-6 px-0"><p class="mb-0">Cota</p></div>
                <div class="col-6 px-0 text-right"><p class="text-body mb-0">{{ debtsConsorcio[0].cota }}</p></div>
              </div>
              <hr class="my-2" />
              <div class="row mx-0 px-1" v-if="normalInstallmentsRange">
                <div class="col-6 px-0"><p class="mb-0">{{ installmentsLabel }}</p></div>
                <div class="col-6 px-0 text-right">
                  <p class="text-body mb-0">{{ normalInstallmentsRange }}</p>
                </div>
              </div>
              <div class="row mx-0 px-1" v-if="hasDiffInstallment">
                <div class="col-6 px-0"><p class="mb-0">Diferença de parcela anterior</p></div>
                <div class="col-6 px-0 text-right">
                  <p class="text-body mb-0">{{ diffInstallmentValueFormatted }}</p>
                </div>
              </div>
              <div class="row mx-0 px-1">
                <div class="col-6 px-0"><p class="mb-0">Valor</p></div>
                <div class="col-6 px-0 text-right"><p class="text-body mb-0">{{ sumSelectedFormatted }}</p></div>
              </div>
              <div class="row mx-0 px-1">
                <div class="col-6 px-0"><p class="mb-0">Vencimento</p></div>
                <div class="col-6 px-0 text-right"><p class="text-body mb-0">{{ dueDatesRange }}</p></div>
              </div>
              <div class="row mx-0 px-1">
                <div class="col-6 px-0"><p class="mb-0">Valor do acordo</p></div>
                <div class="col-6 px-0 text-right"><p class="text-body mb-0" style="font-weight: bold;">{{ agreementValueFormatted }}</p></div>
              </div>
              <hr class="my-2" />
              <div class="row mx-0 px-1">
                <div class="col-6 px-0"><p class="mb-0">Vencimento do boleto</p></div>
                <div class="col-6 px-0 text-right"><p class="text-body mb-0">{{ formatData(offerInfo.dueDate, 'YYYY-MM-DD', 'L') }}</p></div>
              </div>
              <div class="row mx-0 px-1">
                <div class="col-6 px-0"><p class="mb-0">Forma de pagamento</p></div>
                <div class="col-6 px-0 text-right"><p class="text-body mb-0">Boleto</p></div>
              </div>
              <hr />
              <div class="row mt-3 mb-1 px-2">
                <div class="col-lg-1 text-center px-1 col-1" style="align-content: center">
                  <i class="fa fa-info-circle text-info"></i>
                </div>
                <div class="px-1 col-lg-11 col-11">
                  <p class="small">
                    O pagamento das parcelas em atraso é fundamental para garantir a sua participação na próxima assembleia. O prazo de compensação do pagamento é de até 2 dias úteis.
                  </p>
                  <p class="small mb-0">
                    Lembre-se: manter as parcelas em dia garante sua participação nas assembleias e evita o cancelamento da sua cota.
                  </p>
                </div>
              </div>

              <div class="row d-flex justify-content-center mt-3">
                <div class="text-center col-md-12">
                  <button class="btn mb-4 btn-primary p-3" style="width: 100%; border-radius: 20px" :disabled="loadSetAgreement" data-toggle="modal" data-target="#confirmAgreementModal">
                    CONFIRMAR ACORDO
                  </button>
                </div>
              </div>
              <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-if="loadSetAgreement">
                <ProgressLoading v-bind:loading="loadSetAgreement" />
              </div>
            </div>
          </div>
    </div>
    <div
      class="modal fade"
      id="confirmAgreementModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="confirmAgreementModalLabel"
      aria-hidden="true"
      style="background-color: #212540"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div
          class="modal-content"
          :style="
            largura < 500
              ? 'margin: 30px !important;'
              : 'margin: 90px !important'
          "
        >
          <div class="modal-header">
            <h5 class="modal-title" id="confirmAgreementModalLabel">
              Confirmar acordo
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="option-label text-bold">
              Você deseja confirmar a oferta e formalizar o acordo?
            </p>
            <div class="mt-3">
              <ProgressLoading v-bind:loading="loadSetAgreement" />
            </div>
            <button
              class="btn btn-primary btn-block text-white mt-4"
              style="cursor: pointer; border-radius: 0.9rem; min-height: 40px"
              @click="fecharAcordo()"
              v-if="!loadSetAgreement"
            >
              CONFIRMAR ACORDO
            </button>
            <div class="mt-3 text-center">
              <a
                class=""
                data-dismiss="modal"
                style="cursor: pointer; color: #0046c0"
                v-if="!loadSetAgreement"
              >
                CANCELAR
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  formatCurrencieValueBRL as formatValue,
  formatData,
  formatDocument,
  truncateString,
} from "@/utils/helpers";
import ProgressLoading from "../../../modules/auth/components/ProgressLoading.vue";
import { initializeGlobals } from "@/global";
import { sendAgreementCompletedBeacon } from "@/utils/abandonmentBeacon";

export default {
  name: "resumo-acordo",
  components: {
    ProgressLoading,
  },
  data() {
    return {
      containParcel: false,
      loadSetAgreement: false,
      parcelado: false,
      offerInfo: [],
      isPst: false,
      from: null,
      isWithEntryValue: false,
      pageLocation: null,
      userDataStorage: {},
      userAdm: {},
      ipUser: null,
      installmentsSelectedToShow: [],
      fromToConsorcioProduct: {
        'IMV': 'CONSORCIO - IMÓVEIS',
        'AUT': 'CONSORCIO - AUTOMÓVEIS'
      },
      fromToConsorcioType: {
        'nao contemplado': 'Ativa (não contemplado)',
        'contemplado sem bem': 'Ativa (contemplado sem bem)',
        'contemplado com bem': 'Ativa (contemplado com bem)'
      },
      
    };
  },

  async created() {
    this.loadingSetAgreement = false;
    this.updateCustomData();
    this.ipUser = localStorage.getItem("ipUser");
    localStorage.setItem("currentPageName", this.$options.name);
    this.userDataStorage = JSON.parse(localStorage.getItem("userData"));
    this.userAdm = JSON.parse(localStorage.getItem("userAdm"));
    this.protocol = window.location.protocol;
    this.host = window.location.host;
    this.path = window.location.pathname;
    this.pageLocation = this.protocol + "//" + this.host + this.path;

    this.largura = window.screen.width;
    this.debtsConsorcio = this.$route.params.debtsConsorcio;
    this.offerInfo = this.$route.params.offerInfo;
    this.installmentsSelected = this.$route.params.installmentsSelected;
    this.cardOffers = this.$route.params.cardOffers;
    this.agreements = this.$route.params.agreements;
    this.sumTotalInstallmentsConsorcio = this.$route.params.sumTotalInstallmentsConsorcio;

    console.log('offerInfo: ' + JSON.stringify(this.offerInfo))

    this.offerInfo.installments.map((parcel) => {
      this.installmentsSelected.map((installment) => {
        if(parseInt(installment.installmentNumber) === parseInt(parcel.installmentNumber)) {
            this.installmentsSelectedToShow.push(parcel);
        }
      })
    })

    this.isWithEntryValue = this.$route.params.isWithEntryValue;

    this.isPst = this.$route.params.isPst;
    this.loading = false;
  },
  methods: {
    formatValue,
    formatData,
    formatDocument,
    truncateString,
    
    // Verifica se uma parcela é de diferença (installmentNumber = 0 e C_PCTIPD = 2)
    isDiffInstallmentCheck(inst) {
      const installmentNumber = parseInt(inst.installmentNumber || 0);
      const c_pctipd = String(inst.C_PCTIPD || inst.c_pctipd || "");
      return installmentNumber === 0 && c_pctipd === "2";
    },

    ...mapActions("meusContratos", ["ActionGetAgreementPortoSeguro"]),

    async fecharAcordo() {
      this.eventClickConfirmarGTM();

      this.loadSetAgreement = true;

      // Para Consórcio, paymentOptionCode vem diretamente do cardOffers
      let paymentOptionCodeFinal = null;
      if (this.cardOffers && this.cardOffers.paymentOptionCode) {
        paymentOptionCodeFinal = parseInt(this.cardOffers.paymentOptionCode);
      } else if (this.offerInfo.paymentOptionsCodeIds && this.offerInfo.paymentOptionsCodeIds.length > 0) {
        paymentOptionCodeFinal = this.offerInfo.paymentOptionsCodeIds.filter(
          (value) => {
            return Object.values(value)[0].includes(
              this.offerInfo.installmentsNumber
            );
          }
        )[0];
        if (paymentOptionCodeFinal) {
          paymentOptionCodeFinal = parseInt(Object.keys(paymentOptionCodeFinal)[0]);
        }
      } else if (this.offerInfo.paymentOptionCode) {
        paymentOptionCodeFinal = parseInt(this.offerInfo.paymentOptionCode);
      }

      try {
        const response = await this.ActionGetAgreementPortoSeguro({
          clientCode: this.offerInfo.clientCode,
          credor: this.offerInfo.credor,
          paymentOptionCode: paymentOptionCodeFinal,
          plan: this.offerInfo.plan || this.cardOffers?.paymentOptions?.[0]?.plan || "1",
          invoiceOption: this.offerInfo.invoiceOption || "Boleto",
          contract: this.offerInfo.contract,
          tag: localStorage.getItem("tag"),
          phoneNumber:
            this.user.PhoneNumber != null
              ? this.user.PhoneNumber
              : this.user.MobileNumber,
          agreementType: this.offerInfo.agreementType || "ParcelamentoRecupera",
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
          hasEmail:
            this.user.Email !== null && this.user.Email !== "" ? true : false,
        });

        this.flashMessage.show({
          timeout: 1000,
          status: "success",
          title: "Sucesso",
          blockClass: "custom-block-class",
          message: "Acordo fechado com sucesso",
        });
        sendAgreementCompletedBeacon(
          this.user?.DebtorID,
          parseInt(process.env.VUE_APP_OWNER_ID),
        );
        this.eventCallbackSuccessAgreementGTM(response.installmentCode);
        this.fecharModalConfirmarAcordo();
        this.verBoletos(response);
      } catch (error) {
        this.flashMessage.show({
          time: 3000,
          status: "error",
          position: "top right",
          title: "Erro",
          message:
            "Não foi possível fechar o acordo, tente novamente mais tarde!",
        });
        this.eventCallbackErrorAgreementGTM(error);
        this.buildAndSetUserData(
          this.userDataStorage.cpfCnpj,
          this.userDataStorage.id,
          this.protocol + "//" + this.host + "/dashboard",
          "Dashboard"
        );
        this.updateCustomData();
        // this.$router.push({
        //   name: "dashboard"
        // });
      } finally {
        this.loadSetAgreement = false;
      }
    },

    async verBoletos(value) {
      this.buildAndSetUserData(
        this.userDataStorage.cpfCnpj,
        this.userDataStorage.id,
        this.protocol + "//" + this.host + "/dashboard/meus-boletos",
        "meus-boletos"
      );
      this.updateCustomData();
      this.$router.push({
        name: "meusBoletos",
        params: {
          agreementInfo: {
            clientCode: this.offerInfo.clientCode,
            group: this.offerInfo.group,
            cota: this.offerInfo.cota,
            credor: this.offerInfo.credor,
            product: this.offerInfo.product,
            contract: this.offerInfo.contract,
            ...value,
            // Ao fechar acordo consórcio: paymentValue deve ser o valor negociado
            paymentValue: value.negociatedValue != null ? value.negociatedValue : value.paymentValue,
          },
          fromProposals: true,
          isConsorcio: true,
          from: 'propostasConsorcio',
        },
      });
    },

    formatFloatToReal(value) {
      return value.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    back() {
      this.eventClickToBackGTM();
      // if (this.from === "propostas") {
      //   this.buildAndSetUserData(
      //     this.userDataStorage.cpfCnpj,
      //     this.userDataStorage.id,
      //     this.protocol + "//" + this.host + "/dashboard/propostas",
      //     "propostas"
      //   );
      //   this.updateCustomData();
      //   this.offerInfo.dueDate = this.offerInfo.dueDateOriginal;
      //   this.$router.push({
      //     name: "propostas",
      //     params: { offerInfo: this.offerInfo },
      //   });
      // } 
      // else if (this.from === "propostasCdc") {
        this.buildAndSetUserData(
          this.userDataStorage.cpfCnpj,
          this.userDataStorage.id,
          this.protocol + "//" + this.host + "/dashboard/propostasConsorcio",
          "propostasConsorcio"
        );
        this.updateCustomData();
        this.$router.push({
          name: "propostasConsorcio",
          params: {
            offerInfo: this.offerInfo,
            from: "resumoAcordoConsorcio",
            sumTotalInstallmentsConsorcio: this.sumTotalInstallmentsConsorcio,
            debtsConsorcio: this.debtsConsorcio,
            agreements: this.agreements,
            installmentsSelected: this.installmentsSelected,
            // totalInstallmentsCdcWithFees: this.totalInstallmentsCdcWithFees,
          },
        });
      // } 
      // else {
      //   this.buildAndSetUserData(
      //     this.userDataStorage.cpfCnpj,
      //     this.userDataStorage.id,
      //     this.protocol + "//" + this.host + "/dashboard/propostasContencioso",
      //     "propostasContencioso"
      //   );
      //   this.updateCustomData();
      //   this.$router.push({
      //     name: "propostasContencioso",
      //     params: { offerInfo: this.offerInfo },
      //   });
      // }
    },

    buildAndSetUserData(doc, id, pageLocation, pageName) {
      // const pageName = this.$options.name;
      const userData = {
        cpfCnpj: doc, // Substitua pelo CPF/CNPJ real
        id: id, // Substitua pelo ID real
        page_location: pageLocation,
        pageName: pageName,
      };
      localStorage.setItem("userData", JSON.stringify(userData));
    },

    eventClickToBackGTM() {
      this.pageName =
        localStorage.getItem("currentPageName") === null
          ? "dashboard"
          : localStorage.getItem("currentPageName");
      const eventCategory = `portal-de-negociacao:porto:${this.pageName}`;
      const eventAction = "click:button:voltar";

      const eventData = {
        event: "select_content",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: this.isPst
          ? this.buildPayloadOfferChoosePST()
          : this.buildPayloadOfferChoose(),
        product_identify: this.offerInfo.contract,
        product_category: this.offerInfo.product,
        product_user_profile: "titular",
        brand: "porto",
        product: this.offerInfo.product,
        vertical: "bank",
      };

      window.dataLayer.push({ event: "select_content", ...eventData });
    },

    buildPayloadOfferChoose() {
      var formatedPayload = null;
      if (this.offerInfo.installmentsNumber === 1) {
        formatedPayload = `Valor de desconto:${this.formatFloatToReal(
          parseFloat(this.offerInfo.value, 10)
        )}:Pagamento à vista de ${this.formatFloatToReal(
          parseFloat(this.offerInfo.installmentValue, 10)
        )}`;
      } else {
        var value = this.offerInfo.inputValue
          ? this.formatFloatToReal(parseFloat(this.offerInfo.inputValue, 10))
          : this.formatFloatToReal(
              parseFloat(this.offerInfo.installmentValue, 10)
            );
        formatedPayload = `Valor de desconto:${this.formatFloatToReal(
          parseFloat(this.offerInfo.value, 10)
        )}: Entrada de ${value} + ${
          this.offerInfo.installmentsNumber - 1
        }x ${this.formatFloatToReal(
          parseFloat(this.offerInfo.installmentValue, 10)
        )}`;
      }
      return truncateString(formatedPayload, 100);
    },

    buildPayloadOfferChoosePST() {
      var formatedPayload = null;
      formatedPayload = `${
        this.offerInfo.installmentsNumber
      }x ${this.formatFloatToReal(
        parseFloat(this.offerInfo.installmentValue, 10)
      )}`;

      return truncateString(formatedPayload, 100);
    },

    eventClickConfirmarGTM() {
      this.pageName =
        localStorage.getItem("currentPageName") === null
          ? "dashboard"
          : localStorage.getItem("currentPageName");
      const eventCategory = `portal-de-negociacao:porto:${this.pageName}`;
      const eventAction = "click:button:confirmar";

      const eventData = {
        event: "select_content",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: this.isPst
          ? this.buildPayloadOfferChoosePST()
          : this.buildPayloadOfferChoose(),
        product_identify: this.offerInfo.contract,
        product_category: this.offerInfo.product,
        product_user_profile: "titular",
        brand: "porto",
        product: this.offerInfo.product,
        vertical: "bank",
      };

      window.dataLayer.push({ event: "select_content", ...eventData });
    },

    eventCallbackSuccessAgreementGTM(value) {
      this.pageName =
        localStorage.getItem("currentPageName") === null
          ? "dashboard"
          : localStorage.getItem("currentPageName");
      const eventCategory = `portal-de-negociacao:porto:${this.pageName}`;
      const eventAction = "confirmar:negociacao:sucesso";

      const eventData = {
        event: "self_service",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: "Acordo fechado com sucesso",
        product_identify: this.offerInfo.contract,
        product_category: this.offerInfo.product,
        product_user_profile: "titular",
        brand: "porto",
        product: this.offerInfo.product,
        vertical: "bank",
        service_protocol: value,
        service_detail: "Acordo fechado com sucesso",
        service_type: "solicitacao",
      };

      window.dataLayer.push({ event: "self_service", ...eventData });
    },

    eventCallbackErrorAgreementGTM(erro) {
      this.pageName =
        localStorage.getItem("currentPageName") === null
          ? "dashboard"
          : localStorage.getItem("currentPageName");
      const eventCategory = `portal-de-negociacao:porto:${this.pageName}`;
      const eventAction = "confirmar:negociacao:alert";

      const eventData = {
        event: "alert",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label:
          "Não foi possível fechar o acordo, tente novamente mais tarde!",
        product_identify: this.offerInfo.contract,
        product_category: this.offerInfo.product,
        product_user_profile: "titular",
        brand: "porto",
        product: this.offerInfo.product,
        vertical: "bank",
        alert_code: erro.status,
        error_service: "",
        alert_service_message: erro.message,
        alert_event: "self_service",
        alert_type: "erro",
      };

      window.dataLayer.push({ event: "self_service", ...eventData });
    },

    updateCustomData() {
      const globals = initializeGlobals();
      window.customData = globals.customData;
    },

    fecharModalConfirmarAcordo() {
      const modal = document.getElementById("confirmAgreementModal");

      modal.classList.remove("show");
      modal.style.display = "none";

      const backdrop = document.querySelector(".modal-backdrop");
      if (backdrop) {
        backdrop.remove();
      }

      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("minhasDividas", [
      "agreementResume",
      "contractNegotiable",
      "contractNegotiableOptions",
    ]),
    // Verifica se há parcela de diferença
    hasDiffInstallment() {
      if (!this.installmentsSelected || this.installmentsSelected.length === 0) return false;
      return this.installmentsSelected.some(inst => this.isDiffInstallmentCheck(inst));
    },
    // Retorna as parcelas normais (não são diferença de parcela)
    normalInstallments() {
      if (!this.installmentsSelected || this.installmentsSelected.length === 0) return [];
      return this.installmentsSelected.filter(inst => !this.isDiffInstallmentCheck(inst));
    },
    // Range das parcelas normais (sem diferença de parcela)
    normalInstallmentsRange() {
      if (this.normalInstallments.length === 0) return "";
      const ordered = [...this.normalInstallments].sort((a, b) => parseInt(a.installmentNumber) - parseInt(b.installmentNumber));
      const first = ordered[0].installmentNumber;
      const last = ordered[ordered.length - 1].installmentNumber;
      return first === last ? `${first}` : `${first} a ${last}`;
    },
    // Retorna a parcela de diferença
    diffInstallment() {
      if (!this.installmentsSelected || this.installmentsSelected.length === 0) return null;
      return this.installmentsSelected.find(inst => this.isDiffInstallmentCheck(inst));
    },
    // Valor formatado da parcela de diferença
    diffInstallmentValueFormatted() {
      if (!this.diffInstallment) return "";
      const value = this.diffInstallment.originalValue || this.diffInstallment.value || 0;
      return (parseFloat(value) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
    // Label dinâmico: "Parcela" ou "Parcela(s)"
    installmentsLabel() {
      return this.normalInstallments.length > 1 ? "Parcela(s)" : "Parcela";
    },
    installmentsRange() {
      if (!this.installmentsSelected || this.installmentsSelected.length === 0) return "--";
      const ordered = [...this.installmentsSelected].sort((a, b) => parseInt(a.installmentNumber) - parseInt(b.installmentNumber));
      const first = ordered[0].installmentNumber;
      const last = ordered[ordered.length - 1].installmentNumber;
      return first === last ? `${first}` : `${first} a ${last}`;
    },
    dueDatesRange() {
      if (!this.installmentsSelected || this.installmentsSelected.length === 0) return "--";
      const ordered = [...this.installmentsSelected].sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate));
      const first = this.formatData(ordered[0].dueDate, "YYYY-MM-DD", "L");
      const last = this.formatData(ordered[ordered.length - 1].dueDate, "YYYY-MM-DD", "L");
      return first === last ? `${first}` : `${first} e ${last}`;
    },
    sumSelectedFormatted() {
      const total = this.sumTotalInstallmentsConsorcio || 0;
      return (parseFloat(total) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
    agreementValueFormatted() {
      // Prioriza o valor do offer (value) sobre paymentValue
      const value = this.offerInfo && (this.offerInfo.value || this.offerInfo.paymentValue) 
        ? (this.offerInfo.value || this.offerInfo.paymentValue) 
        : 0;
      return (parseFloat(value) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
  },
};
</script>
